import api from './api';

const getAllInvestors = () => {
  return api.get(`investors/profiles`);
};

export { getAllInvestors };
